// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AudioPlayerUI__container-d7655f {
  --audio-player-height: 108px;
  position: relative;
  z-index: 2;
}

.AudioPlayerUI__content-cc4bd7 {
  background-color: var(--base-0);
  padding: 12px 8px;
  position: relative;
  z-index: 1;
}

.AudioPlayerUI__listOpened-afa411 {
  border-top: 1px solid var(--base-30);
}

.AudioPlayerUI__panel-b9eed7 {
  align-items: center;
  display: flex;
  margin-bottom: 8px;
}

.AudioPlayerUI__title-a507f4 {
  flex: 1;
  margin-inline-start: 8px;
  margin-inline-end: 8px;
}

.AudioPlayerUI__controls-d2f929 {
  padding-inline-start: 8px;
  padding-inline-end: 8px;
}

.AudioPlayerUI__progress-ef553b {
  height: 4px;
  margin: 4px 0 12px;
  --progress-background: var(--base-30);
  --progress-pin-size: 12px;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Media/AudioPlayer/AudioPlayerUI/AudioPlayerUI.styles.m.css"],"names":[],"mappings":"AAAA;EACE,4BAAA;EAEA,kBAAA;EACA,UAAA;AAAF;;AAGA;EACE,+BAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;AAAF;;AAGA;EACE,oCAAA;AAAF;;AAGA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;AAAF;;AAGA;EACE,OAAA;EACA,wBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,WAAA;EACA,kBAAA;EAEA,qCAAA;EACA,yBAAA;AADF","sourcesContent":[".container {\n  --audio-player-height: 108px;\n\n  position: relative;\n  z-index: 2;\n}\n\n.content {\n  background-color: var(--base-0);\n  padding: 12px 8px;\n  position: relative;\n  z-index: 1;\n}\n\n.listOpened {\n  border-top: 1px solid var(--base-30);\n}\n\n.panel {\n  align-items: center;\n  display: flex;\n  margin-bottom: 8px;\n}\n\n.title {\n  flex: 1;\n  margin-inline-start: 8px;\n  margin-inline-end: 8px;\n}\n\n.controls {\n  padding-inline-start: 8px;\n  padding-inline-end: 8px;\n}\n\n.progress {\n  height: 4px;\n  margin: 4px 0 12px;\n\n  --progress-background: var(--base-30);\n  --progress-pin-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AudioPlayerUI__container-d7655f`,
	"content": `AudioPlayerUI__content-cc4bd7`,
	"listOpened": `AudioPlayerUI__listOpened-afa411`,
	"panel": `AudioPlayerUI__panel-b9eed7`,
	"title": `AudioPlayerUI__title-a507f4`,
	"controls": `AudioPlayerUI__controls-d2f929`,
	"progress": `AudioPlayerUI__progress-ef553b`
};
module.exports = ___CSS_LOADER_EXPORT___;
